import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedNoteListList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseNotes {
  search?: string;
  ordering?: string;
  athleteId?: string;
  limit?: string;
}

function useNotes({
  search,
  ordering,
  athleteId,
  limit = '20',
}: IUseNotes): UseInfiniteQueryResult<AxiosResponse<PaginatedNoteListList>> {
  const fetchNotes = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedNoteListList>> => {
    const params = pageParam;

    if (search) {
      params.search = search;
    }

    if (athleteId) {
      params.athlete = athleteId;
    }

    if (ordering) {
      params.ordering = '-pinned,'
        .concat(ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`))
        .concat(',pk');
    }

    return client.get(`notes/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['notes', search, ordering, athleteId], fetchNotes, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useNotes;
